import getInternacional from './internacional'

/**
 * Redondea un valor numérico según la configuración regional de decimales
 * @param {number} value - Valor a redondear
 * @param {string} countryCode - Código del país (ej: 'cl', 'pe', 'co')
 * @returns {number} - Valor redondeado
 */
export const roundToRegionalDecimals = (value, countryCode = 'cl') => {
  if (value === null || value === undefined || isNaN(value)) {
    return 0
  }
  
  const config = getInternacional(countryCode)
  const decimals = config.currency_decimals
  
  // Convertir a número y redondear según la configuración regional
  const numValue = parseFloat(value)
  const multiplier = Math.pow(10, decimals)
  const rounded = Math.round(numValue * multiplier) / multiplier
  
  return rounded
}

/**
 * Formatea un valor numérico para mostrar en inputs según la configuración regional
 * @param {number} value - Valor a formatear
 * @param {string} countryCode - Código del país
 * @returns {string} - Valor formateado para input
 */
export const formatForInput = (value, countryCode = 'cl') => {
  if (value === null || value === undefined || isNaN(value)) {
    return ''
  }
  
  const config = getInternacional(countryCode)
  const decimals = config.currency_decimals
  
  // Redondear y formatear para input
  const rounded = roundToRegionalDecimals(value, countryCode)
  
  // Si no hay decimales, mostrar como entero
  if (decimals === 0) {
    return Math.round(rounded).toString()
  }
  
  // Si hay decimales, mostrar con la cantidad correcta
  return rounded.toFixed(decimals)
}

/**
 * Calcula el saldo pendiente considerando la configuración regional
 * @param {number} total - Total de la factura
 * @param {number} paid - Total pagado
 * @param {string} countryCode - Código del país
 * @returns {number} - Saldo pendiente redondeado
 */
export const calculateRemainingBalance = (total, paid, countryCode = 'cl') => {
  const totalRounded = roundToRegionalDecimals(total, countryCode)
  const paidRounded = roundToRegionalDecimals(paid, countryCode)
  const remaining = totalRounded - paidRounded
  
  return roundToRegionalDecimals(remaining, countryCode)
} 